
export const useDoorValues = () => {
  const webUrl = process.env.VUE_APP_DOOR_WEB_ORIGIN || 'http://127.0.0.1:5500'
  const orgAdminUrl = process.env.VUE_APP_DOOR_ORG_ADMIN_ORIGIN || 'http://127.0.0.1:5500'
  const originUrls = [
    webUrl,
    orgAdminUrl
  ]

  const decideOriginUrl = (origin) => {
    return originUrls.filter((url) => url === origin)
  }
  const containsOrigin = (origin) => {
    return originUrls.includes(origin)
  }
  const appTitle = 'Door.'

  return {
    decideOriginUrl,
    containsOrigin,
    appTitle
  }
}
